<script setup>
import { defineProps } from "vue";
import { AisRangeInput } from "vue-instantsearch/vue3/es";
import AlgoliaSlider from "./AlgoliaSlider.vue";

const props = defineProps({
  filterAttribute: {
    type: String,
  },
});
</script>

<template>
  <ais-range-input :attribute="props.filterAttribute" :precision="1">
    <template #default="{ currentRefinement, range, refine, canRefine }">
      <AlgoliaSlider :current-refinement="currentRefinement" :range="range" :refine="refine" :can-refine="canRefine" />
    </template>
  </ais-range-input>
</template>